/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatchProjectTagsRequest } from '../../models/patch-project-tags-request';
import { ProjectTagsResponse } from '../../models/project-tags-response';

export interface ProjectsControllerPatchTags$Params {

/**
 * Project id.
 */
  id: string;
      body: PatchProjectTagsRequest
}

export function projectsControllerPatchTags(http: HttpClient, rootUrl: string, params: ProjectsControllerPatchTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectTagsResponse>> {
  const rb = new RequestBuilder(rootUrl, projectsControllerPatchTags.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectTagsResponse>;
    })
  );
}

projectsControllerPatchTags.PATH = '/planning-projects/v1-preview/projects/{id}/tags';
